import React, { useMemo, useState } from 'react';
import { createContext, ReactElement } from "react";
import { Actions } from '../services/react-query/permissions';
import usePermissionAllowed from '../hooks/usePermissionAllowed';
import { useGetCurrentOrganization } from '../services/react-query/organization';

type DisableContextType = {
  disabled: boolean;
  selfDisable: React.Dispatch<boolean>,
}

export const DisableContext = createContext<DisableContextType>({ disabled: false, selfDisable: () => null });

interface IDisableContextProviderProps {
  permission: Actions;
  children: ReactElement;
}

export default function DisableContextProvider({ permission, children }: IDisableContextProviderProps) {
  const [selfDisabled, setSelfDisabled] = useState(false);
  const { data: organization } = useGetCurrentOrganization({ enabled: !selfDisabled });
  const permissionAllowed = usePermissionAllowed(permission);

  const enabled = !selfDisabled && permissionAllowed && organization?.subscription_status !== 'paused';

  return (
    <DisableContext.Provider value={{ disabled: !enabled, selfDisable: setSelfDisabled }}>
      {children}
    </DisableContext.Provider>
  );
}

export function disableWrappedPage(Page: React.FC, permission: Actions) {
  return (
    <DisableContextProvider permission={permission}>
      <Page />
    </DisableContextProvider>
  );
}
